import React, { Component } from 'react';
import "./TeamPage.css";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import userProfilImage from "../../assets/icon_user_profile.svg";
import { ProfileCard } from "../Peers/PeersPage"
import close_icon from "../../assets/left-arrow-black.svg"

class TeamPage extends Component {
  componentDidMount() {
    document.body.style.background = "white";
  }

  onClose = () => {
    return this.props.history.goBack()
  }

  render() {
    return (
      <div className="team-background">
        <div className="test">
          <img className="back_arrow cursor-pointer" onClick={this.onClose} src={close_icon} alt="back" />
          <TeamPageBaseB />
        </div>
      </div>
    );
  }
}

const INITIAL_STATE = {
  teams: [],
  current_user: null,
  current_uid: null,
  users: null,
  managerID: '',
};

class TeamPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, };
  }

  componentDidMount() {
    document.body.style.backgroundColor = "white";
    let uid;
    if (this.props.firebase.auth.currentUser) {
      uid = this.props.firebase.auth.currentUser.uid
      this.setState({ current_uid: uid });
      this.props.firebase.db
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const cu = doc.data();
            this.setState({ current_user: cu, managerID: doc.data().manager });
          } else {
            console.error("No such document!");
          }
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });

      this.props.firebase.db.collection('users')
        .get()
        .then(querySnapshot => {
          const users = querySnapshot.docs.map(doc => doc.data());
          this.setState({
            users: users,
            teams: users.filter(user => user.manager === this.state.current_uid)
          })
        })
    }
  }

  render() {
    const {
      teams,
    } = this.state;

    return (
      <div className="container">
        <h1 className="text-center title_team">Mon équipe</h1>
        <div className="row text-center">
          <div className="col-sm-1 col-md-1"></div>
          <div className="col-sm-12  col-md-10 flex-test">
            {teams.map((team) => <div className="">
              <div className="mr-3 mb-5">
                <ProfileCard
                  image_profile={team.image_url_profile ? team.image_url_profile : userProfilImage}
                  firstname={team.firstname}
                  lastname={team.lastname}
                  position={team.position ? team.position : "Poste non renseigné"} />
              </div>
            </div>)}
          </div>
          <div className="col-sm-1 col-md-1"></div>
        </div>
      </div>
    );
  }
}


const TeamPageBaseB = withRouter(withFirebase(TeamPageBase));
export { TeamPageBaseB };
export default TeamPage;